import { apiClient } from './apiClient';

const API_V1 = '/api/v1';

export type AdminUserRecord = {
  id: string;
  firstName: string | null;
  lastName: string | null;
  primaryEmail: string | null;
  isAdmin: boolean;
  salesforceId: string | null;
  salesforceUsername: string | null;
  salesforceProfileId: string | null;
  createdAt: number;
  lastSignInAt: number | null;
  imageUrl: string;
};

export const adminService = {
  listUsers(token: string): Promise<AdminUserRecord[]> {
    return apiClient.getJson<AdminUserRecord[]>(`${API_V1}/admin/users`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
